<template>
  <div>
    <div class="w-full mb-4">
      <p class="text-sm text-gray-500 leading-relaxed text-justify">{{ form.description }}</p>
    </div>

    <div class="flex flex-col space-y-6">
      <div>
        <p class="font-medium text-gray-700 mb-3">{{ $t('select_columns_to_show_in_task_table') }}</p>
        
        <div class="space-y-4">
          <div>
            <p class="text-sm font-semibold text-gray-600 mb-2">{{ $t('date_columns') }}</p>
            <div class="flex flex-col space-y-3">
              <div class="flex justify-between items-center w-full">
                <span class="text-gray-700">{{ $t('baseline') }}</span>
                <b-switch size="is-small" v-model="form.settings.baseLine"/>
              </div>

              <div class="flex justify-between items-center w-full">
                <span class="text-gray-700">{{ $t('baseline_latest') }}</span>
                <b-switch size="is-small" v-model="form.settings.lastPlanned"/>
              </div>

              <div class="flex justify-between items-center w-full">
                <span class="text-gray-700">{{ $t('actual') }}</span>
                <b-switch size="is-small" v-model="form.settings.actual"/>
              </div>
            </div>
          </div>

          <div>
            <p class="text-sm font-semibold text-gray-600 mb-2">{{ $t('progress_columns') }}</p>
            <div class="flex flex-col space-y-3">
              <div class="flex justify-between items-center w-full">
                <span class="text-gray-700">{{ $t('baseline_progress') }}</span>
                <b-switch size="is-small" v-model="form.settings.baseLineProgress"/>
              </div>

              <div class="flex justify-between items-center w-full">
                <span class="text-gray-700">{{ $t('latest_planning_progress') }}</span>
                <b-switch size="is-small" v-model="form.settings.lastPlannedProgress"/>
              </div>

              <div class="flex justify-between items-center w-full">
                <span class="text-gray-700">{{ $t('executed1') }}</span>
                <b-switch size="is-small" v-model="form.settings.actualProgress"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveConfigPage } from '../services/report-detail.service.js';

export default {
  name: "PageTaskColumSelectorConfigForm",

  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    reportConfigs: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    const settings = this.initialData.settings || {};
    return {
      form: {
        ...this.initialData,
        settings: {
          ...settings,
          baseLine: settings.baseLine !== undefined ? settings.baseLine : true,
          lastPlanned: settings.lastPlanned !== undefined ? settings.lastPlanned : false,
          actual: settings.actual !== undefined ? settings.actual : true,
          baseLineProgress: settings.baseLineProgress !== undefined ? settings.baseLineProgress : false,
          lastPlannedProgress: settings.lastPlannedProgress !== undefined ? settings.lastPlannedProgress : false,
          actualProgress: settings.actualProgress !== undefined ? settings.actualProgress : false,
        }
      }
    };
  },

  methods: {
    submit() {
      saveConfigPage(this.form, this.reportConfigs)
      this.$emit('epc-save', this.form);
    },
  }
}
</script>